@if (rating >= 0 && rating <= 9) {
  <i class="fa-solid fa-star text-muted"></i>
} @else if (rating >= 10 && rating <= 49) {
  <i class="fa-solid fa-star nz-color-star"></i>
} @else if (rating >= 50 && rating <= 199) {
  <i class="fa-solid fa-star nz-color-star"></i>
  <i class="fa-solid fa-star nz-color-star"></i>
} @else if (rating >= 200 && rating <= 499) {
  <i class="fa-solid fa-star nz-color-star"></i>
  <i class="fa-solid fa-star nz-color-star"></i>
  <i class="fa-solid fa-star nz-color-star"></i>
} @else if (rating >= 500 && rating <= 999) {
  <i class="fa-solid fa-gem nz-color-gem"></i>
} @else if (rating >= 1000 && rating <= 2499) {
  <i class="fa-solid fa-gem nz-color-gem"></i>
  <i class="fa-solid fa-gem nz-color-gem"></i>
} @else if (rating >= 2500 && rating <= 4999) {
  <i class="fa-solid fa-gem nz-color-gem"></i>
  <i class="fa-solid fa-gem nz-color-gem"></i>
  <i class="fa-solid fa-gem nz-color-gem"></i>
} @else if (rating >= 5000 && rating <= 9999) {
  <i class="fa-solid fa-crown nz-color-crown"></i>
} @else if (rating >= 10000 && rating <= 19999) {
  <i class="fa-solid fa-crown nz-color-crown"></i>
  <i class="fa-solid fa-crown nz-color-crown"></i>
} @else if (rating >= 20000) {
  <i class="fa-solid fa-crown nz-color-crown"></i>
  <i class="fa-solid fa-crown nz-color-crown"></i>
  <i class="fa-solid fa-crown nz-color-crown"></i>
}
@if (!hiddenValue) {
  <span>({{ rating }})</span>
}
